(function ($) {

    class ProductGallery extends HTMLElement {
        constructor() {
            super();
            this.options = {
                selectedTab: 'features',
                pernum: 6,  //展示6个缩略图
            };
            this.mainSwiper = null;
            this.fullscreenSwiper = null;
            // this.senseHandlerInstance = new SenseHandler();
            this.currentMediaId = '';
            this.previousMediaId = '';
            this.mediaTypeIdList = {
                features: [],
                video: [],
                options: []
            };
            this.mediaTypeList = [];
            this.mediaMap = new Map();
            if (this.classList.contains('product-gallery--autoinit')) {
               this.load();
            }
            this.bindEvent();
            this.initGalleryNode();
            this.fullscreenOpenStatus = false;
            this.trackStartedTime = null;
            this.canTrackPictureExposure = true;
        }

        get mainSwiperClass() {
            return 'product-gallery .product-media-gallery';
        }

        get fullscreenWrapperClass() {
            return 'product-gallery .product-gallery__fullscreen_slider';
        }


        initGalleryNode() {
            this.$gallery = $('[data-js-product-gallery]');
            this.$main_slider = this.$gallery.find('[data-js-product-gallery-main-slider]');
            this.$thumbnail_slider = this.$gallery.find('[data-js-product-gallery-thumbnail-slider]');
            this.$thumbnail_items = this.$thumbnail_slider.find('[data-js-product-gallery-thumbnail-item]');
            this.$thumbnail_arrow_prev = this.$gallery.find('[data-js-product-gallery-thumbnail-arrow-prev]');
            this.$thumbnail_arrow_next = this.$gallery.find('[data-js-product-gallery-thumbnail-arrow-next]');
            this.$fullscreen = $('.product-gallery__fullscreen');
            this.$fullscreenSlider = $('.product-gallery__fullscreen_slider');
            this.$fullscreenControl = this.$fullscreen.find('[data-js-product-gallery-control-fullscreen]');
        }

        load() {
            this.$gallery = $('[data-js-product-gallery]');
            var options_global = this.$gallery.find('[data-json-options-global]'),
                options_layout = this.$gallery.find('[data-json-options-layout]');

            options_global = options_global.length ? JSON.parse(options_global.html()) : {};
            options_layout = options_layout.length ? JSON.parse(options_layout.html()) : {};

            this.options = $.extend(true, {}, this.options, options_global, options_layout);
            let currentMediaId = this.options.media_id_index[0];
            this.initData();

            this.initMediaGallery();
            this.initGalleryNode();

            // const queryParams = __Xtool_Utils.getQueryParams();
            // if (queryParams.variant) {
            //     const currentVariant = this.options.current_variant; 
            //     if (currentVariant && currentVariant.featured_media) {
            //         currentMediaId = currentVariant.featured_media.id;
            //     }
            // }
            // this.updateCurrentMediaId(currentMediaId);
        }

        // 初始化媒体数据
        initData() {
            var list = [];
            let tempMediaTypeIndex = 0;
            for (var i = 0 ; i < this.options.media_id_index.length; i++) {
                const mediaId = this.options.media_id_index[i];
                const $thumbnailItem = $(`[data-js-product-gallery-thumbnail-item][data-image-id=${mediaId}]`);
                const mediaType = $thumbnailItem.attr('data-item-media-type');

                let url = $thumbnailItem.find('img').attr('src');
                if (this.options.is_single_media) {
                    url = $('[data-js-product-gallery-main-single] img').attr('src');
                }
                
                const lastMediaType = list[i - 1]?.mediaType;

                if (!lastMediaType || lastMediaType !== mediaType) {
                    tempMediaTypeIndex = 0;
                } else {
                    tempMediaTypeIndex ++;
                }
                var data = {
                    mediaId: mediaId,
                    mediaType: mediaType,
                    mediaTypeIndex: tempMediaTypeIndex,
                    index: i,
                    url
                }
                list.push(data);
                this.mediaMap.set(mediaId, data);
                if (this.mediaTypeIdList[mediaType]) {
                    this.mediaTypeIdList[mediaType].push(mediaId);
                }
            }
            this.mediaList = list;

            // 检查是否有视频资源，如果没有则隐藏tabs
            if (!this.mediaTypeIdList.video || this.mediaTypeIdList.video.length === 0) {
                $('.product-gallery__tabs').hide();
            }
        }

        initMediaGallery() {
            var _ = this;
            const swiper = new Swiper(this.mainSwiperClass, {
                mousewheel: {
                    forceToAxis: true,
                    thresholdDelta: 10
                },
                loop: true,
                navigation: {
                    nextEl: `${this.mainSwiperClass} .product-media-gallery__button-next`,
                    prevEl: `${this.mainSwiperClass} .product-media-gallery__button-prev`,
                },
                autoplay: false,
                on: {
                    slideChange: function (a) {
                        if (this.previousIndex) {
                            const prevMediaId = this.slides[this.previousIndex].dataset.itemMediaId;
                            _.updatePreviousMediaId(prevMediaId);
                        }
                        const currentMediaId = this.slides[this.activeIndex].dataset.itemMediaId;
                        _.updateCurrentMediaId(currentMediaId);
                     
                    }
                  }
            });
            this.mainSwiper = swiper;
            this.thumbnailSlider = $('[data-js-product-gallery-thumbnail-slider]');
        }

        // 视频播放状态
        updateVideoPlayStatus() {
            const mediaInfo = this.mediaMap.get(+this.currentMediaId);
            const prevMediaInfo = this.mediaMap.get(+this.previousMediaId);  
            if (mediaInfo && mediaInfo.mediaType === 'video') {
                this.loadMedia(this.currentMediaId);
            }
            if (prevMediaInfo && prevMediaInfo.mediaType === 'video') {
                this.pauseMedia(this.previousMediaId);
            }
        }

        // 获取目标视频, 全屏、主图都可以调用
        getTargetVideo(id) {
            let targetClass = this.mainSwiperClass;
            if (this.fullscreenOpenStatus) {
                targetClass = this.fullscreenWrapperClass;
            }
            const $currentSwipperItem = $(targetClass).find(`[data-item-media-id=${id}]`);

            return $currentSwipperItem && $currentSwipperItem.find('video');
        }

        // 加载视频资源
        loadMedia(id) {
            const video = this.getTargetVideo(id);
            if (video && video.length) {
                const dataSrc = video.attr('data-src');
                const src = video.attr('src');
                if (!src && dataSrc) {
                    $(video).attr('src', dataSrc);
                }
                setTimeout(() => {
                    video.attr('autoplay', 'autoplay');
                    video.get(0).play();
                }, 10)
            }
        }
  
        // 暂停视频播放
        pauseMedia(id) {
            const video = this.getTargetVideo(id);
            if (video && video.length) {
                video.get(0).pause();
            }
        }

        getMediaIdByVariantId(variantId) {
            const variants = this.options.variants;
            const currentVariant = variants.find(variant => variant.id === variantId);
            return currentVariant && currentVariant.featured_media && currentVariant.featured_media.id;
        }

        // 绑定事件
        bindEvent() {
            const _ = this;
            // 点击分类事件
            $('.product-gallery__tabs').on('click', '.product-gallery__tabs_item', function () {
                const $this = $(this);
                const dataFilter = $this.attr('data-filter');
                let mediaId = null;
                if (dataFilter === _.options.selectedTab) {
                    return;
                }

                const currentTypeMediaIdList = _.mediaTypeIdList[dataFilter];
                if (currentTypeMediaIdList.length) {
                    mediaId = currentTypeMediaIdList[0];
                }
                if (dataFilter === 'video') {
                    _.trackGalleryClick(_.currentMediaId, 'video_button', '');
                }

                if (mediaId) {
                    _.updateCurrentMediaId(mediaId, 0);
                }
            });

            // 缩略图点击事件
            $('[data-js-product-gallery-thumbnail-item]').on('click', function(e) {
                const mediaId = e.currentTarget.dataset.imageId;
                _.trackGalleryClick(mediaId, 'small_picture', '');
                _.updateCurrentMediaId(mediaId, 0);
            })

            if (window.innerWidth >= 1024) {
                // 主图点击事件
                this.$main_slider.on('click', (e) => {
                    const target = e.target;
                    if (target.closest('.product-media-gallery__button-next')) {
                        _.trackGalleryClick(_.previousMediaId, 'big_picture_switch_button', 'right');
                        return;
                    }
                    if (target.closest('.product-media-gallery__button-prev')) {
                        _.trackGalleryClick(_.previousMediaId, 'big_picture_switch_button', 'left');
                        return;
                    }
                    if (target.closest('.product-gallery__main_item--type-video')) return;
                    this.handleShowfullScreen();
                });

                // 关闭全屏
                this.$fullscreenControl.on('click', () => {
                    this.handleCloseFullscreen();
                })
            }

            // 监听产品页gallery，更新媒体id
            // document.addEventListener('on::product::gallery::update', (e) => {
            //     if (e.detail.id) {
            //         this.updateCurrentMediaId(e.detail.id, 0);
            //     }
            // })

            document.addEventListener('visibilitychange', function () {
                // 用户息屏、或者切到后台运行 （离开页面）
                if (document.visibilityState === 'hidden') {
                    _.trackPictureExposure(_.currentMediaId);
                }
                // 用户打开或回到页面
                if (document.visibilityState === 'visible') {
                    _.setTrackStartedTime();
                }
            })
            // 监听滚动
            $(window).on('scroll', theme.throttle((e) => {
                if (this.isGalleryInViewPort()) {
                    _.canTrackPictureExposure = true;
                    if (!_.trackStartedTime) {
                        _.setTrackStartedTime();
                    }
                } else {
                    _.trackPictureExposure(_.currentMediaId);
                    _.canTrackPictureExposure = false;
                    _.trackStartedTime = null;
                }
            }, 300));

            // 监听缩略图箭头点击事件
            this.currentPage = this.getCurPage();
            this.$thumbnail_arrow_prev.on('click', () => {
                _.trackGalleryClick(_.currentMediaId, 'small_picture_switch_button', 'left');
                this.handleThumbnailArrowClick('prev');
            });
            this.$thumbnail_arrow_next.on('click', () => {
                _.trackGalleryClick(_.currentMediaId, 'small_picture_switch_button', 'right');
                this.handleThumbnailArrowClick('next');
            });
            $('.product-page-get-gallery-video-button').on('click', () => {
                const currentTypeMediaIdList = _.mediaTypeIdList['video'];
                _.trackGalleryClick(_.currentMediaId, 'video_button', '');
                if (currentTypeMediaIdList.length) {
                    _.updateCurrentMediaId(currentTypeMediaIdList[0], 0);
                }
            })
        }

        // 缩略图箭头点击事件
        handleThumbnailArrowClick(direction) {
            if (direction === 'prev') {
                this.currentPage--;
            } else {
                this.currentPage++;
            }
            this.handleTransformThumbnail(true);
        }

        // 判断是否显示 save 标签
        // handleIfBadgeShow() {
        //     const $badge = $(".product-badge_main");
        //     const hasInit = $badge.attr('data-has-init');
        //     if(!hasInit) return;
        //     const inventoryQuantity = $badge.attr("data-inventory-quantity");
        //     const currentMediaInfo = this.mediaMap.get(this.currentMediaId);
        //     const mediaType = currentMediaInfo && currentMediaInfo.mediaType;
        //     if (mediaType === 'options' || mediaType === 'features' && currentMediaInfo.mediaTypeIndex === 0) {
        //         if((inventoryQuantity <= 0 && $badge.find(".inventory-quantity").length)){
        //             $badge.hide();
        //         }else {
        //             document.dispatchEvent(new CustomEvent('setSaveAmount', {
        //                 detail: {
        //                     callback: () => {
        //                         $badge.css("display", "flex");
        //                     }
        //                 }
        //             }));
        //         }
        //     } else {
        //         $badge.hide();
        //     }
        // }

        updatePreviousMediaId(prevId) {
            if (prevId) {
                this.previousMediaId = +prevId;
            }
        }

        // 更新当前媒体id
        updateCurrentMediaId(id, speed) {
            if (+id === +this.currentMediaId) {
                return;
            }
            this.currentMediaId = +id;
            this.updateVideoPlayStatus();
            // 通过id去切换大图
            this.goToSlideByActiveId(speed);
            // 设置分类tab选中
            this.handleSetSelectTab();
            // 更新页码
            this.handleUpdatePageNum();

            // 判断是否显示 save 标签
            // this.handleIfBadgeShow();

            this.trackPictureExposure(this.previousMediaId);

            setTimeout(() => {
                // 过滤缩略图分类图片
                this.handleFilterThumbnail();
                // 缩略图滑动
                this.handleTransformThumbnail();
                // 缩略图激活
                this.handleThumbnailActive();
                this.setTrackStartedTime();
                // 更新视频按钮状态
                this.updateVideoButtonStatus();
            }, 0)
        }

        // 通过id去切换大图
        goToSlideByActiveId(speed) {
            const currentMediaInfo = this.mediaMap.get(this.currentMediaId);
            if (currentMediaInfo && this.mainSwiper) {
                if (this.mainSwiper.realIndex === currentMediaInfo.index) {
                    return;
                }
                this.mainSwiper.slideToLoop(currentMediaInfo.index, speed);
            }
        }

        // 获取当前页
        getCurPage() {
            let mediaTypeIndex = 0;
            const currentMediaInfo = this.mediaMap.get(this.currentMediaId);
            if (currentMediaInfo && this.options.is_show_product_image_classify) {
                mediaTypeIndex = currentMediaInfo.mediaTypeIndex;
            } else {
                mediaTypeIndex = currentMediaInfo.index;
            }
            return Math.ceil((mediaTypeIndex + 1) / (this.options.pernum));
        }

        // 设置分类tab选中
        handleSetSelectTab() {
            const currentMediaInfo = this.mediaMap.get(this.currentMediaId);
            if (currentMediaInfo) {
                const mediaType = currentMediaInfo.mediaType;
                this.options.selectedTab = mediaType;
                $('.product-gallery__tabs').find('.product-gallery__tabs_item').removeClass('selected');
                $('.product-gallery__tabs').find(`[data-filter="${mediaType}"]`).addClass('selected');
            }
        }

        // 缩略图滑动
        handleTransformThumbnail(isPrev) {
            // 1. 设置滑动参数
            const sliderConfig = {
                normal: {
                    transform: 336, // 每个缩略图的宽度
                    padding: 38,    // 缩略图之间的间距
                },
            };
            
            // 2. 计算最大滑动距离
            const $thumbnailSlides = $('.product-gallery__thumbnail_slides');
            const slidesWidth = $thumbnailSlides.width();
            const maxTransform = Math.max(0, slidesWidth - sliderConfig.normal.transform);
            
            // 3. 获取当前显示的缩略图
            const filteredItems = this.options.is_show_product_image_classify 
                ? $(`[data-js-product-gallery-thumbnail-item].media-${window.innerWidth < 1024 ? this.options.selectedTab : 'features'}`)
                : $(`[data-js-product-gallery-thumbnail-item]`);
            
            // 4. 获取当前媒体信息
            const currentMediaInfo = this.mediaMap.get(this.currentMediaId);
            const isVideo = currentMediaInfo && currentMediaInfo.mediaType === 'video';
            
            // 如果是视频，不进行滑动
            if (isVideo && !isPrev) {
                return;
            }
            
            // 5. 计算总页数和当前页
            const totalPages = Math.ceil(filteredItems.length / this.options.pernum);
            const currentPage = Math.min(Math.max(isPrev ? this.currentPage : this.getCurPage(), 1), totalPages);
            
            // 6. 计算滑动距离
            const baseTransform = (currentPage - 1) * sliderConfig.normal.transform;
            const maxPageTransform = (totalPages - 1) * sliderConfig.normal.transform;
            const transformValue = Math.min(baseTransform, maxPageTransform, maxTransform);
            
            // 7. 应用滑动变换
            $thumbnailSlides.css('transform', `translate3d(-${transformValue}px, 0px, 0px)`);
            
            // 8. 控制箭头显示和状态
            const $prevArrow = this.$thumbnail_arrow_prev;
            const $nextArrow = this.$thumbnail_arrow_next;
            
            if (filteredItems.length > this.options.pernum) {
                // 显示箭头
                $prevArrow.removeClass('d-none-important');
                $nextArrow.removeClass('d-none-important');
                
                // 设置箭头状态
                const setArrowState = ($arrow, isDisabled) => {
                    $arrow.css({
                        'opacity': isDisabled ? 0.5 : 1,
                        'pointer-events': isDisabled ? 'none' : 'auto'
                    });
                };
                
                // 更新箭头状态
                setArrowState($prevArrow, currentPage === 1);
                setArrowState($nextArrow, currentPage === totalPages);
            } else {
                // 隐藏箭头
                $prevArrow.addClass('d-none-important');
                $nextArrow.addClass('d-none-important');
            }
            
            // 9. 更新当前页码
            this.currentPage = currentPage;
        }

        // 过滤缩略图分类图片
        handleFilterThumbnail() {
            var _ = this;
            if (this.$thumbnail_slider.hasClass('d-none-important')) {
                this.$thumbnail_slider.removeClass('d-none-important');
            }
            if (this.options.is_show_product_image_classify && window.innerWidth < 1024) {
                $('[data-js-product-gallery-thumbnail-item]').addClass('d-none-important');
                const filteredItems = $(`[data-js-product-gallery-thumbnail-item].media-${this.options.selectedTab}`);
                filteredItems.removeClass('d-none-important');
            }
            // 在PC端隐藏视频缩略图
            if (window.innerWidth >= 1024) {
                $('[data-js-product-gallery-thumbnail-item]').removeClass('d-none-important');
                $('[data-js-product-gallery-thumbnail-item].media-video').addClass('d-none-important');
            }
        }

        // 缩略图激活
        handleThumbnailActive() {
            $(`[data-js-product-gallery-thumbnail-item][data-image-id=${this.currentMediaId}]`).addClass('current').siblings().removeClass('current');
        }

        // 更新视频按钮状态
        updateVideoButtonStatus() {
            const currentMediaInfo = this.mediaMap.get(this.currentMediaId);
            const isVideo = currentMediaInfo && currentMediaInfo.mediaType === 'video';
            $('.product-page-get-gallery-video-button .video-button-wrapper').toggleClass('active', isVideo);
        }

        // 更新页码
        handleUpdatePageNum() {
            const $mainPaging = $('.product-gallery__main_paging');
            if (!$mainPaging.length) {
                return;
            }
            if ($mainPaging.hasClass('d-none')) {
                $mainPaging.removeClass('d-none');
            }
            const currentMediaInfo = this.mediaMap.get(this.currentMediaId);
            if (currentMediaInfo) {
                let index = 0;
                const currentType = currentMediaInfo.mediaType;
                const $curNum = $mainPaging.find('span.cur_num');
                const $totalNum = $mainPaging.find('span.total_num');
                let totalNum = 0;
                if (this.options.is_show_product_image_classify) {
                    totalNum = this.mediaTypeIdList[currentType].length;
                    index = currentMediaInfo.mediaTypeIndex;
                } else {
                    totalNum = this.mediaMap.size;
                    index = currentMediaInfo.index;
                }
                $curNum.html(+index + 1);
                $totalNum.html(totalNum);
            }
        }

        // 初始化全屏swiper
        initFullScreenSwipper() {
            this.$fullscreen$fullscreen = $('.product-gallery__fullscreen');
            this.$fullscreenSlider = $('.product-gallery__fullscreen_slider');
            this.$fullscreenControl = this.$fullscreen.find('[data-js-product-gallery-control-fullscreen]');
                 
            // 复制主图内容到全屏
            const mainSwiperContent = $(this.mainSwiperClass).find('.swiper-wrapper').html();
            this.$fullscreenSlider.html(`<div class="swiper-wrapper">${mainSwiperContent}</div>`);

            // 初始化全屏swiper
            this.fullscreenSwiper = new Swiper(this.fullscreenWrapperClass, {
                loop: true,
                navigation: {
                    nextEl: '[data-js-product-gallery-fullscreen-arrow-next]',
                    prevEl: '[data-js-product-gallery-fullscreen-arrow-prev]',
                },
                on: {
                    slideChange: (swiper) => {
                        if (swiper.slides.length) {
                            const currentMediaId = swiper.slides[swiper.activeIndex].dataset.itemMediaId;
                            this.updateCurrentMediaId(currentMediaId, 300);
                        }
                    }
                }
            });
        }

        // 显示全屏
        handleShowfullScreen() {
            if (!this.fullscreenSwiper) {
                this.initFullScreenSwipper();
            }
            $body.addClass('product-gallery-fullscreen');
            this.$fullscreen.addClass('visible show');
            this.$fullscreen.find('.swiper-wrapper').addClass('mk-w-[100vh]');
            this.$fullscreenSlider.addClass('mk-w-[100vh]');
            this.$fullscreen.find('.product-gallery__main_item').css('width', '100vh');

            // 获取当前主图的索引
            const currentIndex = this.mainSwiper ? this.mainSwiper.activeIndex : 0;

            // 禁用body滚动
            document.body.style.overflow = 'hidden';
            // 同步当前滑动位置
            if (this.fullscreenSwiper) {
                this.fullscreenSwiper.slideTo(currentIndex, 0);
            }
            this.fullscreenOpenStatus = true;
        }

        // 关闭全屏
        handleCloseFullscreen() {
            const $body = $('body');
            
            // 移除全屏相关类名
            $body.removeClass('product-gallery-fullscreen');
            this.$fullscreen.removeClass('visible show');
            
            // 恢复body滚动
            document.body.style.overflow = '';
            this.fullscreenOpenStatus = false;
        }

        // gallery是否在视图里
        isGalleryInViewPort() {
            if (!this.$gallery.length) {
                return false;
            }
            const rect = this.$gallery.get(0).getBoundingClientRect();
            return rect.bottom >= __Xtool_Utils.getHeaderFixedHeight();
        }
        
        setTrackStartedTime(){
            this.trackStartedTime = Date.now();
        }

        trackPictureExposure(id) {
            if (!id || !this.canTrackPictureExposure) {
                return;
            }
            try {
                const currentMediaInfo = this.mediaMap.get(id);
                const variants = this.options.variants;
                let currentVariant = variants.find(variant => {
                    if (variant.featured_media) {
                        return variant.featured_media.id === id;
                    }
                    return false;
                });
                if (!currentVariant) {
                    const queryParams = __Xtool_Utils.getQueryParams();
                    if (queryParams.variant) {
                        currentVariant = variants.find(variant => variant.id === +queryParams.variant);
                    }
                }
                let sku = variants[0].sku;
                if (currentVariant) {
                    sku = currentVariant.sku;
                }
                if (currentMediaInfo) {
                    let picture_class = '';
                    if ( currentMediaInfo.mediaType) {
                        picture_class = currentMediaInfo.mediaType.charAt(0).toUpperCase() + currentMediaInfo.mediaType.slice(1);
                    }
                    const data = {
                        picture_pagecount: this.mediaMap.size,
                        picture_pagenumber: currentMediaInfo.index + 1,
                        picture_class,
                        picture_url: currentMediaInfo.url,
                        sku,
                        media_files: currentMediaInfo.mediaType
                    };

                    const startedTime = __Xtool_Utils.dateFormat(this.trackStartedTime, 'YYYY-MM-DD HH:mm:ss');
                    const endedTime = __Xtool_Utils.dateFormat(Date.now(), 'YYYY-MM-DD HH:mm:ss');
                    const exposureTime = this.getExposureTime();

                    if (SenseBlock.track) {
                        SenseBlock.track('PictureExposure', {
                            ...data,
                            strated_time: startedTime,
                            finished_time: endedTime
                        });
                    }
                    if (SenseBlock.gtmTrack) {
                        SenseBlock.gtmTrack('picture_exposure', {
                            ...data,
                            item_id: sku,
                            started_time: startedTime, 
                            finished_time: endedTime,
                            exposure_time: exposureTime,
                            product_title: this.options.product_title,
                            product_id: this.options.product_id
                        })
                    }
                }
            } catch (e) {
                console.error(e);
            }
        }

        trackGalleryClick(id, resource_location, switch_direction = '') {
            if (!id) {
                return;
            }
            const currentMediaInfo = this.mediaMap.get(+id);
            const picturePagenumber = currentMediaInfo.index + 1;
            const data = {
                resource_location: resource_location,
                picture_pagenumber: picturePagenumber,
                switch_direction: switch_direction,
                product_title: this.options.product_title,
                product_id: this.options.product_id,
                media_files: currentMediaInfo.mediaType
            }
            if (SenseBlock.gtmTrack) {
                SenseBlock.gtmTrack('click_actions_in_gallery', data);
            }
        }

        // 获取曝光时长
        getExposureTime() {
            // 计算总秒数
            const timeDiff = Date.now() - this.trackStartedTime;
            return Math.floor(timeDiff / 1000);
        }
    }

    theme.AssetsLoader.onPageLoaded(function () {
        customElements.define('product-gallery', ProductGallery);
    });
    class DeliveryCountdown extends HTMLElement {
        constructor() {
            super();

            this.daysOfWeek = [
                theme.strings.delivery_countdown.days_of_week.sunday,
                theme.strings.delivery_countdown.days_of_week.monday,
                theme.strings.delivery_countdown.days_of_week.tuesday,
                theme.strings.delivery_countdown.days_of_week.wednesday,
                theme.strings.delivery_countdown.days_of_week.thursday,
                theme.strings.delivery_countdown.days_of_week.friday,
                theme.strings.delivery_countdown.days_of_week.saturday
            ];

            setTimeout(() => {
                this.elementCounter = this.querySelector('[data-js-delivery-countdown-counter]');
                this.elementDelivery = this.querySelector('[data-js-delivery-countdown-delivery]');

                this.deliveryTime = +this.dataset.deliveryTime;
                this.resetTime = +this.dataset.resetTime;
                this.deliveryFormat = this.dataset.deliveryFormat;
                this.excludes = this.dataset.deliveryExcludes.replace(/ /gi, '').toLowerCase().split(',');

                this.start();
            }, 0);
        }

        start() {
            this.display();
            this.interval = setInterval(() => this.display(), 1000);
        }

        display() {
            this.render(this.getRemainingTime());
        }

        getTotal() {
            return Date.parse(this.finalDate) - Date.parse(new Date());
        }

        getRemainingTime() {
            const now = new Date();

            this.finalDate = now;
            this.finalDate.setDate(this.finalDate.getDate() + 1);
            this.finalDate.setHours(this.resetTime, 0, 0, 0);

            const counterTotal = this.getTotal();
            const counterMinutes = Math.floor((counterTotal / 1000 / 60) % 60);
            const counterHours = Math.floor((counterTotal / (1000 * 60 * 60)) % 24);

            let finalyDeliveryTime = this.deliveryTime;
            let startExcludesDate = 0;

            // if (now.getHours() >= this.finalDate.getHours() && now.getMinutes() >= this.finalDate.getMinutes() && now.getSeconds() >= this.finalDate.getSeconds()) {
            //     finalyDeliveryTime++;
            //     startExcludesDate++;
            // }

            const deliveryDate = now;
            let endExcludesDate = this.deliveryTime + startExcludesDate + 1;

            for (let i = startExcludesDate; i < endExcludesDate; i++) {
                let currentDate = new Date();

                currentDate.setDate(currentDate.getDate() + i);

                if (this.excludes.indexOf(this.daysOfWeek[currentDate.getDay()].toLowerCase()) !== -1) {
                    deliveryDate.setDate(deliveryDate.getDate() + 1);
                    endExcludesDate++;
                }
            }

            deliveryDate.setDate(deliveryDate.getDate() + finalyDeliveryTime);

            return {
                counter: {
                    hours: counterHours,
                    minutes: counterMinutes
                },
                delivery: deliveryDate
            };
        }

        render(data) {
            const { counter, delivery } = data;
            let counterHTML = '';

            if (counter.hours) {
                counterHTML += `${counter.hours} ${theme.strings.delivery_countdown.hours.toLowerCase()} `;
            }

            counterHTML += `${counter.minutes} ${theme.strings.delivery_countdown.minutes.toLowerCase()}`;
            this.elementCounter.innerHTML = counterHTML;
            this.elementDelivery.innerHTML = this.deliveryFormat.toLowerCase()
                .replace('day', this.daysOfWeek[delivery.getDay()])
                .replace('dd', ('0' + delivery.getDate()).slice(-2))
                .replace('mm', ('0' + (delivery.getMonth() + 1)).slice(-2))
                .replace('yyyy', delivery.getFullYear())
                .replace('yy', delivery.getFullYear().toString().slice(-2));
        }

        disconnectedCallback() {
            if (this.inrerval) clearInterval(this.inrerval);
        }
    }

    theme.AssetsLoader.onPageLoaded(function () {
        customElements.define('delivery-countdown', DeliveryCountdown);
    });

    // 暂不使用的功能
    // class VisitorsCounter extends HTMLElement {
    //     constructor() {
    //         super();
    //         this.load();
    //     }

    //     load() {
    //         this.counter = this.querySelector('[data-js-counter]');
    //         this.valueMin = this.dataset.min;
    //         this.valueMax = this.dataset.max;
    //         this.intervalMin = this.dataset.intervalMin;
    //         this.intervalMax = this.dataset.intervalMax;
    //         this.stroke = this.dataset.stroke;

    //         this.interval = setInterval(() => {
    //             this.update();
    //         }, this.randomInteger(this.intervalMin, this.intervalMax) * 1000);
    //     }

    //     update() {
    //         this.getNewValue();
    //         this.render();
    //     }

    //     render() {
    //         this.counter.innerHTML = this.currentValue;
    //     }

    //     getNewValue() {
    //         const currentValue = this.counter.text;
    //         const newValue = this.randomInteger(this.valueMin, this.valueMax);

    //         if(Math.abs(currentValue - newValue) > this.stroke) {
    //             newValue = newValue > currentValue ? currentValue + this.stroke : currentValue - this.stroke;
    //             newValue = this.randomInteger(currentValue, newValue);
    //         }

    //         this.currentValue = newValue;
    //     }

    //     randomInteger(min, max) {
    //         return Math.round(min - 0.5 + Math.random() * (max - min + 1));
    //     }

    //     disconnectedCallback() {
    //         clearInterval(this.interval);
    //     }
    // }

    // theme.AssetsLoader.onPageLoaded(function() {
    //     customElements.define('visitors-counter', VisitorsCounter);
    // });

    class SingleProduct extends HTMLElement {
        constructor() {
            super();

            setTimeout(() => {
                this.update();
            }, 0);
        }

        update() {
            if (theme.isLoaded) {
                theme.StoreLists.checkProductStatus(this);
            }
            theme.dynamicCheckout.load(this);
        }
    }

    theme.AssetsLoader.onPageLoaded(function () {
        customElements.define('single-product', SingleProduct);
        theme.AssetsLoader.require('scripts', 'mkt_component_description');
    });

    class CrowdProcess extends HTMLElement {
        constructor() {
            super();
            this.init();
        }
        init() {
            var fetch_freq = Number(this.dataset.freq) || 10000;
            this.target_number = Number(this.dataset.goal) || 1000;
            if (!this.target_number || !fetch_freq) {
                return;
            }
            var crowdSectionEl = $("#crowd-progress-section");
            this.progressBarEl = crowdSectionEl.find(".progress-bar");
            this.progressGoalEl = crowdSectionEl.find(".crowd-progress-goal");
            this.backerNumberEl = crowdSectionEl.find(".backer-number");
            // 加载初执行一次
            this.fetchCrowdData();
            var that = this;

            var deadline = Number(this.dataset.deadline);
            var interval = setInterval(function () {
                // 截止时间，停止拉取数据
                var timeLeft = (new Date(deadline) - new Date()) / 1000;
                if (timeLeft <= 0) {
                    clearInterval(interval);
                }
                that.fetchCrowdData();
            }, fetch_freq);
        }
        renderView(data) {
            var current_value = data.customers || 0; // todo 0, 750, 1501, 3000
            var current_backers = data.customers || 0; // todo 0, n
            var current_percent = Math.round(current_value * 100 / this.target_number);
            var target_ratio_percent = Math.min(Math.round(this.target_number * 100 / current_value), 100);

            this.progressBarEl.css("width", Math.min(current_percent, 100) + "%")
                .attr("aria-now", current_value)
                .find(".progress-info").text(current_percent + "%");
            this.progressGoalEl.css("width", target_ratio_percent + "%");

            this.backerNumberEl.text(current_backers + ' Backers');
        }
        fetchCrowdData() {
            var that = this;
            $.get("https://dtc.mblock.cc/shopify/f1/saleInfo", function (data) {
                that.progressGoalEl.removeClass('progress-loading');
                // 缓存成功数据，用于失败时取用
                if (data && data.message === 'ok' && data.data) {
                    that.renderView(data.data);
                    localStorage.setItem('crowd_latest_data', JSON.stringify(data.data));
                } else {
                    var crowd_latest_data = localStorage.getItem('crowd_latest_data');
                    try {
                        that.renderView(crowd_latest_data ? JSON.parse(crowd_latest_data) : {});
                    } catch (err) {
                        console.error(err);
                    }
                }
            }).fail(function () {
                var crowd_latest_data = localStorage.getItem('crowd_latest_data');
                try {
                    that.renderView(crowd_latest_data ? JSON.parse(crowd_latest_data) : {});
                } catch (err) {
                    console.error(err);
                }
            })
        }
    }
    theme.AssetsLoader.onPageLoaded(function () {
        customElements.define('crowd-process', CrowdProcess);
    });

    class Product {
        constructor() {
            this.hideZeroReviews();
            this.bindEvent();
            this.affirmCardIcon();
        }
        /**
         * 隐藏评分为0的reviews
         * @returns 
         */
        hideZeroReviews() {
            const $reviews = $('.product-page-info__reviews');
            if (!$reviews.length) {
                return;
            }
            const observer = new MutationObserver(function () {
                const $rating = $reviews.find('.jdgm-prev-badge');
                if (!$rating.length) {
                    return
                }
                const rating = $rating.attr('data-average-rating');
                if (rating != '0.00') {
                    $reviews.removeClass('d-none');
                    observer.disconnect();
                }
            });
            observer.observe($reviews.get(0), { subtree: true, childList: true });
        }
        /**
         * 绑定事件
         */
        bindEvent() {
            // 点击五点描述区的图片滚动到fbt
            $('.jump-to-fbt').click(() => {
                const $fbtContainer = $('.cbb-frequently-bought-container');
                if ($fbtContainer.length > 0) {
                    const fbtTop = $fbtContainer.get(0).getBoundingClientRect().top;
                    let navHeight = __Xtool_Utils.getHeaderFixedHeight();
                    const diffTop = navHeight + 20;
                    const eleTarPosTop = fbtTop + window.pageYOffset - diffTop;
                    window.scrollTo({ top: eleTarPosTop, behavior: "smooth" });
                }
            });

            // 打开one+弹窗
            $('.open-tanchuang-popup').css('cursor', 'pointer');
            $('.open-tanchuang-popup').click(() => {
                //$(".proof-factor-cb-trigger-float-circle").click();
                $('.proof-factor-fw-triggers-floatbutton-circle').click();
            });

            // 
        }

        affirmCardIcon () {
            const $affirmWrapper = $('.product-page-main-affirm-wrapper');
            const $affirm = $affirmWrapper.find('#affirm-as-low-as');
            if (!$affirm.length) {
                return;
            }
            const observer = new MutationObserver(function () {
                // 如果是机器类型并且是abtest， 择隐藏
                if ($affirm.get(0).textContent) {
                    $affirmWrapper.removeClass('d-none-important');
                    const cashBackNode = $affirmWrapper.parent().find('.product_page_cashback');
                    if (cashBackNode.length) {
                        cashBackNode.addClass('product_page_cashback_before_line');
                    }
                }
            });
            observer.observe($affirm.get(0), { subtree: true, childList: true });
        }
    }

    class GraphqlHelper {
        // graphql 请求地址
        static apiUrl = `https://makeblock-xtool.myshopify.com/api/2023-01/graphql.json`;

        static authHeaders() {
            return {
                'x-shopify-storefront-access-token': '7bb184c4d18313c58d0ccd6bfa0f73a3',
            };
        }
        /**
         * 查询请求
         * @param { string } query  query 参数
         * @param { json } variables 变量
         */
        static query(query, variables) {
            return fetch(GraphqlHelper.apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    ...GraphqlHelper.authHeaders(),
                },
                body: JSON.stringify({ query, variables }),
            })
                .then((response) => {
                    if (response.ok) {
                        return response.json();
                    } else {
                        throw { message: `${response.status}: ${response.statusText}` };
                    }
                })
                .catch((err) => {
                    return err.message;
                });
        }
    }
    // class Policy {
    //     constructor() {
    //         let $policyContent;
    //         if ($(window).width() <= 1024) {
    //             $policyContent = $('.hide-in-pc .p-policy-content');
    //         } else {
    //             $policyContent = $('.hide-in-h5 .p-policy-content');
    //         }
    //         const $policyList = $policyContent.find('.p-policy-list');
    //         const policyIds = JSON.parse($policyContent.attr('data-policy') || '[]');
    //         if (policyIds.length == 0) {
    //             return;
    //         }
    //         this.fetchMetaObjectInfo(policyIds).then((res) => {
    //             const list = res.data.nodes.map((item) => {
    //                 let listItem = {
    //                     label: item.fields[0].value,
    //                     svg_icon: item.fields[1].value,
    //                 };
    //                 return listItem;
    //             });
    //             list.map(({ label, svg_icon }) => {
    //                 $policyList.append(`
    //                     <div class="item">
    //                         <div class="word">
    //                             ${svg_icon}
    //                             <span>${label}</span>
    //                         </div>
    //                     </div>
    //                 `);
    //             });
    //             if (list.length > 0) {
    //                 $policyContent.removeClass('d-none');
    //                 if (list.length == 2) {
    //                     $policyList.addClass('two');
    //                 }
    //             }
    //         });
    //     }
    //     async fetchMetaObjectInfo(ids) {
    //         const query = `query($ids: [ID!]!) {
    //               nodes(ids: $ids) {
    //                 ... on Metaobject {
    //                   id
    //                   type
    //                   fields {
    //                     key
    //                     value
    //                   }
    //                 }
    //               }
    //             }
    //         `;
    //         const variables = `{
    //           "ids": ${JSON.stringify(ids)}
    //         }`;
    //         const result = await GraphqlHelper.query(query, variables);
    //         return result;
    //     };
    // }
   
    function onlyLabel() {
        $('.product-page__package-variant .disabled-hidden').each(function() {
            const displayBlock = $(this).css('display') === 'block';
            const topLabel = $(this).siblings('.product-page__package-variant_top_label');
            
            if (displayBlock && topLabel.length > 0) {
                topLabel.addClass('d-none');
            } else {
                topLabel.removeClass('d-none');
            }
        });
    }

    // function handleQuizEntry() {
    //     const $quizEntry = $('.product-page-info__options');
        
    //     if ($quizEntry.length > 0) {
    //         $('.pakeage-question-tip-no-options').addClass('d-none');
    //     } else {
    //         $('.pakeage-question-tip-no-options').removeClass('d-none');
    //     }
    // };
    theme.AssetsLoader.onPageLoaded(function () {
        new Product();
        // new Policy();

        onlyLabel();
        // handleQuizEntry();

        window.onlyLabel = onlyLabel;
        document.addEventListener('theme:product::switchVariant', () => {
            onlyLabel();
        });
    });
})(jQueryTheme);